import {MoneyLabel} from "../../../../general/MoneyLabel.tsx";
import {
    toCentsFromMoney,
    toDecimalFromMoney,
    toMoneyFromCents,
    type Money,
} from "../../../../../lib/Money.ts";
import type {ViewRow} from "../../types";
import {signColorClass} from "./tableStyles.ts";
import type { CurrencyEnum } from '../../../../../generated/enums.ts';

const AMOUNT_CELL_CLASS = "text-[13px] tabular-nums";
const ZERO_AMOUNT_LABEL = "0,00";

function ZeroAmount({colorClass = "text-gray-400"}: {colorClass?: string}) {
    return <span className={`${AMOUNT_CELL_CLASS} ${colorClass}`}>{ZERO_AMOUNT_LABEL}</span>;
}

export function AmountCell({cents, currency = "EUR"}: {cents: number; currency?: CurrencyEnum}) {
    if (cents === 0) return <ZeroAmount />;
    return (
        <span className={AMOUNT_CELL_CLASS}>
            <MoneyLabel value={toDecimalFromMoney(toMoneyFromCents(cents, currency))} />
        </span>
    );
}

export function SignedMoneyCell({money}: {money: Money}) {
    const signedCents = toCentsFromMoney(money);
    const color = signColorClass(signedCents);
    if (signedCents === 0) return <ZeroAmount colorClass={color} />;
    return (
        <span className={`${AMOUNT_CELL_CLASS} ${color}`}>
            <MoneyLabel value={Math.abs(toDecimalFromMoney(money))} />
        </span>
    );
}

export function SlimAmountCell({row}: {row: ViewRow}) {
    return <SignedMoneyCell money={row.signed_net} />;
}
